
////////////// DEPENDENCIES AND MODULES /////////////////////////////
/////////////////////////////////////////////////////////////////////

import React, {Component} from 'react';


import LandingSearch from '../LandingSearch/LandingSearch.js'

import './LandingPage.css'




////////////// COMPONENT ////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

class LandingPage extends Component {

  render() {

      return (
        <div className="LandingPageDiv">

          {/* <img src="../../../LandingPage-img-1.jpg" alt="welcome" height="403" width="700" /> */}
          <img src="./LandingPage-img-1.jpg" alt="welcome" height="403" width="700" />

          <LandingSearch />

        </div>
      )

  }
}

////////////// EXPORT MODULE ////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

export default LandingPage;



/////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.js